module.exports = __webpack_public_path__ + "static/media/Slice33@2x.fb85b5a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice33@2x.png
// module id = 1466
// module chunks = 0